/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalDependencies } from './dependenciesEqual.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDeepEqual } from '../../factoriesAny.js';
export var deepEqualDependencies = {
  equalDependencies: equalDependencies,
  typedDependencies: typedDependencies,
  createDeepEqual: createDeepEqual
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDeepEqual.generated.js
// module id = 1522
// module chunks = 0